import React from "react";

export default function About() {
  return (
    <section id="about" className="py-5 bg-light">
      <div className="container">
        <h2 className="text-center mb-4">About Me</h2>

        <div className="row align-items-center">
          {/* Profile image */}
          <div className="col-md-4 text-center mb-4 mb-md-0">
            <img
              src="/images/natalie.jpg"
              alt="About me"
              className="img-fluid rounded-circle shadow"
              style={{ width: "280px", height: "280px", objectFit: "cover" }}
            />
          </div>

          {/* Main Content */}
          <div className="col-md-8">
            <h4 className="fw-bold">
              Aspiring Front-End Developer & Career Switcher
            </h4>

            <p className="text-muted">
              <strong>
                Hi, I’m Natalie — a career-switching, coffee-fuelled aspiring
                Front-End Developer who decided it was finally time to stop
                saying “I want to work in tech” and actually do it.
              </strong>
            </p>

            <p className="text-muted">
              After working in a totally different field, I realised the part I
              enjoyed most was solving problems, organising chaos, and creating
              things that actually help people. Once I discovered front-end
              development, it clicked instantly. Code? Design? Logical thinking
              mixed with creativity? Yes please.
            </p>

            <p className="text-muted">
              Now I’m fully committed to learning everything I can about
              building responsive, beautiful, user-friendly websites. I spend my
              days experimenting with
              {""} <strong>HTML, CSS, JavaScript, and React</strong>, and my
              nights trying to convince myself that I don’t need “just one more
              tutorial”.
            </p>

            <p className="text-muted">
              Switching careers hasn’t been easy, but it’s been exciting,
              challenging, motivating, and genuinely fun. I bring real-world
              work experience, communication skills, and the stubborn
              determination of someone who refuses to give up until things
              finally work.
            </p>

            <p className="text-muted">
              If you want to know more about where I’ve been and where I’m
              headed, feel free to check out my résumé below!
            </p>

            <a
              href="/natalie-resume.pdf"
              className="btn btn-info mt-3"
              target="_blank"
              rel="noreferrer"
            >
              Download My Resume
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
